import getAssetName from '../utils/getAssetName'

export function registerDirectives(requireContext, context) {
  const directiveFiles = requireContext.keys()

  return directiveFiles.map((file) => {
    const name = getAssetName(file)
    let directive = requireContext(file)
    // Unwrap "default" from ES6 module
    if (Object.prototype.hasOwnProperty.call(directive, 'default')) directive = directive.default

    if (typeof directive === 'function') {
      directive = directive.call(null, context)
      context.vueApp.directive(name, directive)
    } else if (typeof directive === 'object' && typeof directive.install === 'function') {
      context.vueApp.use(directive, context)
    } else {
      context.vueApp.directive(name, directive)
    }

    // Return the registered directive
    return { name, directive }
  })
}

export default function loadDirectives(vueApp, context) {
  const requireContext = require.context(
    // root folder for components
    './',
    // recursive
    true,
    // include all .js wo index.js
    /\/(?!index\.js$)(?:[^.]+)\.js$/
  )

  return registerDirectives(requireContext, context)
}
